import { formatPrice } from "@utils";
import { toDisplayPercentage } from "@pages/InventoryPage/modules/InventorySummary/components/shared/BonusCard/utils";
import { PredictionPublicationPrice } from "../interfaces/interfaces";
import { TooltipInfo } from "@shared/TooltipInfo/TooltipInfo";

interface Props {
  data: PredictionPublicationPrice;
}

export const VIMPredictionCard = ({ data }: Props) => {
  return (
    <div className="border rounded p-3 w-100">
      <div>
        <div className="title-card d-flex gap-2">
          <TooltipInfo
            message="Probabilidad de superar ese número de visitas en los 15 días posteriores al cambio de precio."
            placement="top"
          />
          Probabilidades de visitas esperadas:
        </div>
        <div className="d-flex gap-2 justify-content-between pt-2">
          <ul className="visits-list">
            {data.probabilidades.map((item) => (
              <li key={`${item.visitas}-${item.probabilidad}`}>
                {item.visitas} visitas →{" "}
                {toDisplayPercentage(item.probabilidad)}%
              </li>
            ))}
          </ul>

          <div className="d-flex gap-2 justify-content-start flex-column">
            <div className="subtitle-card">Consecuencia:</div>
            <div className="d-flex gap-1 flex-column border rounded p-2 consequence-card">
              <div>
                Margen bruto (%):{" "}
                {toDisplayPercentage(data.margen_bruto_porcentual)}%
              </div>
              <div>Margen ($): {formatPrice(data.margen_bruto)}</div>
              <div>Unit (%): {toDisplayPercentage(data.unit)}%</div>
              <div>Unit ($): {formatPrice(data.unit_tot)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
